export default __webpack_public_path__ + "static/media/img1.8c426a51.png";